import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  pagination: 'Page {pageNumber}/{totalPages}',
})
